export default class DialogColor {
    static GREEN = 'green';
    static RED = 'red';
    static ORANGE = 'orange';
    static PURPLE = 'purple';
    static DARK = 'dark';
    static BLUE ='blue';
    static PRIMARY ='primary';
    static DEFAULT ='default';
}


// WEBPACK FOOTER //
// ./client/app/common/models/dialog/dialogColor.js